<template>
  <div>
    <el-tabs v-model="tabValue">
      <el-tab-pane label="进行中的" name="进行中的">
        <ActivityListPage v-if="tabValue == '进行中的'" />
      </el-tab-pane>

      <el-tab-pane label="活动配置" name="活动配置">
        <ActivityConfigListPage v-if="tabValue == '活动配置'" />
      </el-tab-pane>
      <el-tab-pane label="子活动配置" name="子活动配置">
        <ChildActivityConfigListPage v-if="tabValue == '子活动配置'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
    
<script>
import ActivityConfigListPage from "./ActivityConfigListPage";
import ActivityListPage from "./ActivityListPage";
import ChildActivityConfigListPage from "./ChildActivityConfigListPage";
export default {
  data() {
    return {
      tabValue: "进行中的",
    };
  },

  created() {},

  components: {
    ActivityConfigListPage,
    ActivityListPage,
    ChildActivityConfigListPage,
  },

  methods: {},
};
</script>
    
<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}

.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>
  
    